import { useDispatch, useSelector } from "react-redux";
import { filterVideoLibraryDataTable } from "../../../../../Redux/Actions/VideoLibraryDataTableActions";
import { useEffect } from "react";
import { setFilterValues } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
import CheckBox from "../../../../Checkbox/CheckBox";
import { FaRegCircle, FaCheckCircle } from "react-icons/fa";
import style from "../Filter/Filter.module.css";
const FilterWithOrder = ({ item }) => {
  const { filterValues } = useSelector(
    (state) => state?.videoLibraryFilterData
  );
  const dispatch = useDispatch();
  const tableData = useSelector(
    (state) => state?.VideoLibraryDataTable?.tableData
  );

  useEffect(() => {
    filterValues?.length > 0
      ? filterVideoLibraryDataTable(dispatch, {
          filterConditions: filterValues,
          tableData: tableData,
        })
      : filterVideoLibraryDataTable(dispatch, []);
  }, [filterValues]);

  const handleChange = (isChecked, val) => {
    let newItem = {
      id: val?.mediaBreakdownId,
      value: val?.value,
      operator: "===",
      breakDownName: item?.breakDownName,
    };
    setFilterValues(
      dispatch,
      isChecked
        ? [...(filterValues || []), newItem]
        : filterValues?.filter((el) => el?.id !== val?.mediaBreakdownId)
    );
  };

  const checkSaveValues = (values) => {
    return values?.filter((item) => item?.mediaBreakdownId) || [];
  };

  const getDisplayValue = (value) => {
    switch (value) {
      case "D":
        return "D (Defense)";
      case "O":
        return "O (Offense)";
      case "K":
        return "K (Kick)";
      default:
        return value; // Return the original value for other cases
    }
  };

  //for adding offense defense kick
  const transformedValues = checkSaveValues(item?.values)?.map((el) => ({
    ...el,
    displayValue: getDisplayValue(el.value), // Transform once
  }));

  return (
    <>
      {transformedValues.length > 0 ? (
        transformedValues.map((el) => (
          <div
            className={`d-flex-align-cent gap-10 w-100 ${style.appliedFilterListItem}`}
            key={el.mediaBreakdownId}
          >
            <CheckBox
              checkedIcon={
                <FaCheckCircle
                  className="fs-23"
                  style={{
                    color: "#002244",
                  }}
                />
              }
              defaultIcon={<FaRegCircle className="fs-23" />}
              onChange={(checked) => {
                handleChange(checked, el);
              }}
              checked={filterValues?.some(
                (value) => value?.id === el?.mediaBreakdownId
              )}
            />
            <p className="fs-16 semi-bold">{el.displayValue}</p>{" "}
            {/* Use the transformed value */}
          </div>
        ))
      ) : (
        <p className="semi-bold">
          Column Is Empty. Please Add Some Records & Save the Playlist. Then New
          Records Will Appear Here.
        </p>
      )}
    </>
  );
};

//   return (
//     <>
//       {checkSaveValues(item?.values)?.length > 0 ? (
//         checkSaveValues(item?.values)?.map((el) => (
//           <div
//             className={`d-flex-align-cent gap-10 w-100 ${style.appliedFilterListItem}`}
//           >
//             <CheckBox
//               checkedIcon={
//                 <FaCheckCircle
//                   className="fs-23"
//                   style={{
//                     color: "#002244",
//                   }}
//                 />
//               }
//               defaultIcon={<FaRegCircle className="fs-23" />}
//               onChange={(checked) => {
//                 handleChange(checked, el);
//               }}
//               checked={filterValues?.some(
//                 (value) => value?.id === el?.mediaBreakdownId
//               )}
//             />
//             <p className="fs-16 semi-bold">{getDisplayValue(el.value)}</p>
//           </div>
//         ))
//       ) : (
//         <p className="semi-bold">
//           Column Is Empty. Please Add Some Records & Save the Playlist. Then New
//           Records Will Appear Here.
//         </p>
//       )}
//     </>
//   );
// };

export default FilterWithOrder;
